import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AlertsSearchModel } from "../models/alerts-search";
import {AppSettings} from "../../app-settings";
import {AuthorizationModel} from "../../authentication/models/authorization-model";
import {AppEvents} from "../../app-events";
import * as BootstrapDialog from "bootstrap3-dialog";
import "x-editable/dist/bootstrap3-editable/js/bootstrap-editable";
import { ContainerHelper } from "../../shared/helpers/container-helper";
require("x-editable/dist/bootstrap3-editable/css/bootstrap-editable.css");

const template = require<string>("../views/alerts-search.html");
const dom = {
    SEARCH_DELETE: ".search-delete a",
    SEARCH_ENABLED: ".search-enabled input"
};

@backboneViewProperties({
    tagName: "tr",
    template: template
})
@autoinject
export class AlertsSearchView extends Marionette.ItemView<AlertsSearchModel> {

    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.setupListeners();
    }
    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SEARCH_DELETE] = (e) => this.deleteAlertClick(e);
        events["click " + dom.SEARCH_ENABLED] = (e) => this.alertEnabledClick(e);
        return events;
    }

    public onShow() {
        this.setupEditableFields();
    }

    private setupEditableFields() {
        this.$(".alert-name-link").editable({
            unsavedclass: "",
            success: (response, newValue) => {
                this.model.Name = newValue;
            },
            validate: (newValue) => {
                if (newValue.trim() === "") {
                    return ("Name cannot be empty!");
                }
            }
        });
        this.$(".alert-subject-link").editable({
            unsavedclass: "",
            success: (response, newValue) => {
                this.model.Subject = newValue;
            },
            validate: (newValue) => {
                if (newValue.trim() === "") {
                    return ("Subject cannot be empty!");
                }
            }
        });
    }

    private setupListeners(): void {
        this.listenTo(this.model, "change:Name", () => { this.modelChanged("name", this.model.Name); });
        this.listenTo(this.model, "change:Subject", () => { this.modelChanged("subject", this.model.Subject); });
    }

    private modelChanged(propertyChanged: string, propertyValue: string): void {
        this.appEvents.trigger(AppEvents.AppInsightsAlertChange, {Type: "Search", Value: this.model.Name, PropertyChanged: propertyChanged, PropertyValue: propertyValue});

        this.model.updateSearchAlert().then(() => {
            this.appEvents.trigger(AppEvents.InformationMessage, "Alert update saved.");
        }, () => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert.");
        }).catch((exception) => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert");
        });
    }

    private enabledChanged(): void {
        this.appEvents.trigger(AppEvents.AppInsightsAlertChange, {Type: "Search", Value: this.model.Name, Enabled: this.model.Enabled});

        this.model.updateSearchAlert().then(() => {
            this.$(dom.SEARCH_ENABLED).prop("checked", this.model.Enabled);
            this.$(dom.SEARCH_ENABLED).val("" + this.model.Enabled);
            this.appEvents.trigger(AppEvents.InformationMessage, "The alert '" + this.model.Name + "' has been " + (this.model.Enabled ? "enabled." : "disabled."));
        }, () => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert.");
            this.RevertCheckbox();
        }).catch((exception) => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert");
            this.RevertCheckbox();
        });
    }

    private alertEnabledClick(e: JQueryEventObject): void {
        this.model.Enabled = !this.model.Enabled;
        this.enabledChanged();
    }

    private deleteAlertClick(e: JQueryEventObject): void {
        e.preventDefault();
        e.stopPropagation();

        BootstrapDialog.confirm({
            title: `<strong>Confirm delete?</strong>`,
            message: "Are you sure you want to delete this alert?",
            closable: true,
            btnOKLabel: `<i class="fa fa-check"></i>`,
            btnOKClass: "btn btn-danger",
            btnCancelLabel: `<i class="fa fa-times"></i>`,
            callback: (response) => {
                if (response) {
                    this.confirmDeleteAlert();
                }
            }
        });
    }

    private confirmDeleteAlert(): void {
        this.appEvents.trigger(AppEvents.AppInsightsAlertChange, {Type: "Search", Value: this.model.Name, Delete: true});

        this.model.deleteSearchAlert().then(() => {
            this.appEvents.trigger(AppEvents.InformationMessage, "The alert '" + this.model.Name + "' has been deleted successfully.");
            this.destroy();
            this.model.destroy();
        }, () => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to delete alert.");
        }).catch((exception) => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to delete alert.");
        });
    }

    private RevertCheckbox() {
        this.model.Enabled = !this.model.Enabled;
        this.$(dom.SEARCH_ENABLED).prop("checked", this.model.Enabled);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-search.ts